import { renderDropdown } from "components/MediaTel/DropdownAutoComplete";
import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appdataSelector } from "reducers/appdata/appdata";
import VendordataEditableGeneral from "./VendordataEditableGeneral";
import Button from "@mui/material/Button";
import classnames from "classnames";
import vendordata, { vendor_save_to_sap, vendordataSelector } from "reducers/vendordata/vendordata";
import { Autocomplete, TextField } from "@mui/material";
import VendordataEditableContact from "./VendordataEditableContact";
import VendordataEditableBank from "./VendordataEditableBank";
import VendordataEditablePurchasingData from "./VendordataEditablePurchasingData";
import Loader from "components/Loading/Loader";

const pagelist = {
  COMPANY: "General/Company data",
  CONTACT: "Contact Data",
  BANK: "Bank Data",
  PURCHASING: "Purchasing Data"
};

function VendordataEditable() {
  const appdata = useSelector(appdataSelector);
  const vendordata = useSelector(vendordataSelector);
  const dispatch = useDispatch();
  const [renderPart, setRenderPart] = useState("COMPANY");
  const [languageSelected, setLanguageSelected] = useState(null);

  const handlePaginationChange = key => {
    console.log("handlePaginationChange", key);
    setRenderPart(key);
  };
  const handleLanguageChange = language => {
    console.log("language changed to ", language);
    setLanguageSelected(language);
  };

  const handleSave = () => {
    console.log("Save");
    dispatch(vendor_save_to_sap());
  };

  let languages = [];
  languages.push({ NATION: "", NATION_TEX: "Default" });

  appdata.listvalues.languagesForGeneralData.map((key, value) => {
    languages.push(key);
  });

  if (!languageSelected) {
    setLanguageSelected({ NATION: "", NATION_TEX: "Default" });
  }

  const showSaveButton = () => {
    if (vendordata.saving) return false;
    return true;
  };

  const checkHighlight = (key) =>{
    if(appdata.highlightRequiredFields && vendordata.incompleteRequiredFields.hasOwnProperty(key))
    return "red"
    return "black";
  }



  console.log("languages", languages);
  return (
    <div>
      <div className="border-bottom mb-2"></div>
      {/* navigation */}
      {/* navigation */}
      {/* navigation */}
      {/* navigation */}
      <nav aria-label="Page navigation example">
        <ul className="pagination">
          {Object.keys(pagelist).map(key => {

            return (
              <li className="page-item" key={"paginationlist" + key}>
                <a
                  style={{ color: checkHighlight(key) }}
                  /* style={props.styles[checkar[value]]} */
                  className="page-link"
                  key={"hello" + pagelist[key]}
                  onClick={() => handlePaginationChange(key)}
                >
                  {pagelist[key]}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* language */}
      {/* language */}
      {/* language */}
      {/* language */}
      {/* //TODO: add default selecton language */}
      {renderPart == "COMPANY" && (
        <div className="d-flex justify-content-end">
          <Autocomplete
            style={{
              width: 400,
              marginTop: 0,
              backgroundColor: "white"
            }}
            id="languagesForGeneralData"
            options={languages}
            value={languageSelected ? languageSelected : null}
            renderInput={params => (
              <TextField
                {...params}
                label="International Versions"
                variant="outlined"
              />
            )}
            onChange={(event, value) => {
              console.log("handle language change", event, value);
              handleLanguageChange(value);
            }}
            getOptionLabel={option => {
              if (!option) return null;
              return "" + option.NATION_TEX;
            }}
            isOptionEqualToValue={(option, value) =>
              option.NATION_TEX === value.NATION_TEX
            }
          />
        </div>
      )}

      {/* general */}
      {/* general */}
      {/* general */}
      {/* general */}
      {renderPart == "COMPANY" && (
        <VendordataEditableGeneral
          languageSuffix={languageSelected ? languageSelected["NATION"] : null}
        ></VendordataEditableGeneral>
      )}


      {/* contact */}
      {/* contact */}
      {/* contact */}
      {/* contact */}
      {renderPart == "CONTACT" && (
        <VendordataEditableContact
          languageSuffix={languageSelected ? languageSelected["NATION"] : null}
        ></VendordataEditableContact>
      )}

      {/* bank */}
      {/* bank */}
      {/* bank */}
      {/* bank */}
      {renderPart == "BANK" && (
        <VendordataEditableBank
          languageSuffix={languageSelected ? languageSelected["NATION"] : null}
        ></VendordataEditableBank>
      )}

      {/* purchasing data*/}
      {/* purchasing data*/}
      {/* purchasing data*/}
      {/* purchasing data*/}
      {renderPart == "PURCHASING" && (
        <VendordataEditablePurchasingData
          languageSuffix={languageSelected ? languageSelected["NATION"] : null}
        ></VendordataEditablePurchasingData>
      )}

      {/* save button */}
      {/* save button */}
      {/* save button */}
      {/* save button */}
      {showSaveButton() && (
        <Button
          className={classnames("besiButton", "d-print-none", "mr-4", "mt-4")}
          variant="contained"
          key="savebutton"
          onClick={() => handleSave()}
        >
          Save
        </Button>
      )}

      {/* loading icon */}
      {/* loading icon */}
      {/* loading icon */}
      {/* loading icon */}
      {vendordata.saving && <Loader size="30"></Loader>}
    </div>
  );
}

export default VendordataEditable;
